module.exports = __webpack_public_path__ + "static/media/zoomQuartier_Etang.95155f0e.webp";